import type { BaseResponse } from "@marketplace/shared/types";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import type { VerifyOtpRequestDto } from "../../dtos/verify-otp-request-dto";
import { AuthService } from "../../services/auth-service";

type UsePostSendOtpMutationProps = {
  options?: UseMutationOptions<
    BaseResponse<null>,
    unknown,
    Omit<VerifyOtpRequestDto, "otp_code">
  >;
};

export const usePostSendOtpMutation = ({
  options
}: UsePostSendOtpMutationProps = {}) => {
  return useMutation({
    mutationFn: (payload) => AuthService.sendOtp({ payload }),
    ...options
  });
};
